import { useQuery } from "@tanstack/react-query";
import { useQuerySearch } from "hooks/useQuerySearch";
import { ReactNode } from "react";
import {useNotify} from "react-admin";

export interface ReferenceProps<TResult> {
  children: (data: TResult) => ReactNode;
  loader: ReactNode;
  recordId: any;
  query: (params: { id: any }) => Promise<TResult>;
  queryKey: string;
}

export const Reference = <TResult extends { id: any }>(
  props: ReferenceProps<TResult>
) => {
  const notify = useNotify();

  const { foundedEntity } = useQuerySearch<TResult>({
    queryKey: props.queryKey,
    entityId: props.recordId,
  });

  const query = useQuery({
    queryKey: [props.queryKey, props.recordId],
    queryFn: () =>
      props.query({id: props.recordId}).catch((error) => {
        if (!error?.message) {
          return undefined;
        }

        notify(error?.message, {type: "error"});
      }),
    enabled: props.recordId != null,
    initialData: foundedEntity,
    // refetchOnMount: false,
    staleTime: 1000 * 60 * 5,
  });

  if (!query.data) {
    return <>{props.loader}</>;
  }

  return <>{props.children(query.data)}</>;
};
